<template>
  <div id="centreLeft2">
    <el-dialog title="物料消耗历史" :visible.sync="dialogFormVisible" width="70%">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column v-for="(item,index) in data" :key="index" :prop="item['prop']" :label="item['label']" :width="item['width']">
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
    <div id="bottomLeftBarChart3" style="height: 3.7rem;width: 5.5rem;margin-top: -0.7rem;" @click="checkHistory"></div>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  data() {
    return {
      dialogFormVisible: false,
      listArr: [],
      tableData: [],
      data:[
        {prop: 'today_time',label: '时间',width: '130'},
        {prop: 'S001',label: 'S001'},
        {prop: 'S002',label: 'S002'},
        {prop: 'S003',label: 'S003'},
        {prop: 'S004',label: 'S004'},
        {prop: 'S005',label: 'S005'},
        {prop: 'S006',label: 'S006'},
      ]
    };
  },
  mounted() {
    this.draw();
  },
  created() {
    setTimeout(() => {
      this.getData(this.$store.state['consumList'])
    }, 100)
  },
  computed: {
    listData() {
      return this.$store.state['consumList']
    }
  },
  watch: {
    listData(data) {
      this.getData(data)
    }
  },
  methods: {
    checkHistory(){
      axios({
        url: `http://115.190.8.169:5000/get_consum_data`,
        method: 'GET'
      }).then(res => {
        if (res.data != '网络错误' && res.data.length) {
          this.tableData = res.data
        }
      })
      this.dialogFormVisible = true
    },
    getData(data) {
      data.forEach(item => {
        delete item['id']
        delete item['today_time']
      })
      this.listArr = Object.values(data[0])
      console.log(this.listArr,'vvv')
      this.draw()
    },
    draw() {
      if (this.chart) { this.chart.clear() }
      // 基于准备好的dom，初始化echarts实例
      this.chart = this.$echarts.init(
        document.getElementById("bottomLeftBarChart3")
      );

      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          }
        },
        legend: {},
        grid: {
          left: '2%',
          right: '4%',
          bottom: '5%',
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01],
          axisLine: {  //这是x轴文字颜色
            lineStyle: {
              color: "#fff",
            }
          }
        },
        yAxis: {
          type: 'category',
          data: ['S001', 'S002', 'S003', 'S004', 'S005', 'S006'],
          axisLine: {//这是y轴文字颜色
            lineStyle: {
              color: "#fff",
            }
          }
        },
        series: [
          {
            type: 'bar',
            label: {
              rotate: 90,
              distance: 15
            },
            data: this.listArr,
            color: '#3341fb',
          },
        ]
      };
      this.chart.setOption(option);
    },
  },
  destroyed() {
    window.onresize = null;
  },
};
</script>

<style lang="scss" scoped>
#centreLeft2 {
  margin-right: 0.2rem;
  box-sizing: border-box;
  padding: 0.2rem 0;
  height: 4.5125rem;
  min-width: 11.6rem;
  border-radius: 0.0625rem;

  .bg-color-black {
    height: 4.5125rem;
    border-radius: 0.125rem;
  }

  .text {
    color: #c3cbde;
    font-size: 0.18rem;
  }

  .chart-box {
    margin-top: 0.2rem;
    width: 2.125rem;
    height: 2.125rem;

    .active-ring-name {
      padding-top: 0.125rem;
    }
  }
}
</style>